import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import Nav from '../nav/'
import Color from 'color'
import * as styles from './layout.module.css'
import Footer from '../footer/'
import useThemeColors from '../../hooks/useThemeColors'
import '../../styles/reset.css'
import '../../styles/global.css'

const Layout = ({ children, callout }) => {
  const theme = useThemeColors()
  const white = Color('#FFFFFF')
  const black = Color('#000000')

  // @todo consider moving all of this into a component for ThemeCssVariables or something and removing the hook
  let themeVariables = Object.entries(theme).reduce(function(
    styleString,
    [key, value]
  ) {
    // @todo remove this when we update classes to inclde the word "Color" in the name OR update Contentful field values
    key = key.substring(0, key.length - 5)

    let hex = value.trim()
    let rgb = Color(hex)
      .rgb()
      .array()
      .toString() // created rbg version to add alpha channel

    // @todo add as many adjustments for new variables as you need here
    // @url https://github.com/Qix-/color
    const lightColor = Color(hex)
      .lighten(0.15)
      .hex()
    const darkColor = Color(hex)
      .darken(0.15)
      .hex()

    const contrastColor = Color(hex).isLight() ? black.hex() : white.hex()

    const rgbLightColor = Color(hex)
      .lighten(0.15)
      .rgb()
      .array()
      .toString()
    const rgbDarkColor = Color(hex)
      .darken(0.15)
      .rgb()
      .array()
      .toString()

    styleString += `--${key}:${hex};`
    styleString += `--${key}Light:${lightColor};`
    styleString += `--${key}Dark:${darkColor};`

    styleString += `--${key}Rgb:${rgb};`
    styleString += `--${key}RgbLight:${rgbLightColor};`
    styleString += `--${key}RgbDark:${rgbDarkColor};`

    styleString += `--${key}Contrast:${contrastColor};`

    return styleString
  },
  '')

  themeVariables += `--whiteTransparent-50:${white.fade(0.5)};`
  themeVariables += `--whiteTransparent-90:${white.fade(0.1)};`
  themeVariables += `--blackTransparent-60:${black.fade(0.4)};`

  return (
    <>
      <Helmet>
        <style>{`:root { ${themeVariables} }`}</style>
      </Helmet>
      <Nav />

      <div className={styles.layout}>{children}</div>
      {callout && callout}
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  callout: PropTypes.node,
}

export default Layout
